<template>
  <div class="menu--lang__container">
    <label for="lang"
           class="menu--lang__label"
           :aria-label="$t('aria_label_language_label')"
           :style="{color: this.getTextColor}"
    >{{$t('language')}}</label>
    <select id="lang"
            name="languages"
            class="menu--lang__select"
            v-model="getCurrentLanguageDescription"
            :disabled="getLanguageDescriptions.length < 2"
            :style="{color: `${this.getTextColor} !important`, borderColor: this.getTextColor}">
      <option v-for="(item, index) in getLanguageDescriptions"
              :id="getLanguageId(item)"
              :key="index"
              :value="item"
              :aria-label="getCurrentLanguageDescription === item ? $t('current_lang_selection', {lang: item}) : item"
              :aria-disabled="getCurrentLanguageDescription === item"
              :selected="getCurrentLanguageDescription === item"
              class="menu--lang__option"
      >{{ item }}</option>
    </select>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'language-menu',
  props: {
    bgCol: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getCurrentLanguageDescription',
      'getLanguageDescriptions'
    ]),
    ...mapGetters({
      getFromDesc: 'getLanguageFromDescription'
    }),
    getTextColor () {
      let rgba = this.bgCol.match(/\d+/g)
      if ((rgba[0] * 0.299) + (rgba[1] * 0.587) + (rgba[2] * 0.114) > 186) {
        return 'black'
      } else {
        return 'white'
      }
    },
    getCurrentLanguageDescription: {
      get () {
        let currentLanguage = ''
        this.$store.state.language.languages.forEach((language) => {
          currentLanguage = language.name === this.$store.state.i18n.locale ? language.description : currentLanguage
        })
        return currentLanguage
      },
      set (value) {
        if (value !== undefined) {
          const locale = this.getFromDesc(value)
          this.$i18n.set(locale)
        }
      }
    }
  },
  methods: {
    getLanguageId (language) {
      return language.toLowerCase() + '-id'
    }
  }
}
</script>

<style scoped>

.menu--lang__container {

}

.menu--lang__label {
  margin: 0 0.25em;
}

.menu--lang__select {
  text-align: center;
  border-bottom: 0.125em dashed;
  opacity: 1 !important;
}

.menu--lang__select:focus-visible {
  padding: 0 0.15em;
}

.menu--lang__option {
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/navbar/LanguageMenu.vue